import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/brentvatne/coding/react-native-action-sheet/src/ActionSheet/TouchableNativeFeedbackSafe.tsx";
import * as React from 'react';
import { Platform, TouchableNativeFeedback, TouchableOpacity, View } from 'react-native';

var CustomTouchableOpacity = function (_TouchableOpacity) {
  _inherits(CustomTouchableOpacity, _TouchableOpacity);

  function CustomTouchableOpacity() {
    _classCallCheck(this, CustomTouchableOpacity);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomTouchableOpacity).apply(this, arguments));
  }

  return CustomTouchableOpacity;
}(TouchableOpacity);

CustomTouchableOpacity.SelectableBackground = function () {
  return {};
};

CustomTouchableOpacity.SelectableBackgroundBorderless = function () {
  return {};
};

CustomTouchableOpacity.Ripple = function (color, borderless) {
  return {};
};

var TouchableComponent = Platform.select({
  web: CustomTouchableOpacity,
  default: Platform.Version <= 20 ? CustomTouchableOpacity : TouchableNativeFeedback
});

var TouchableNativeFeedbackSafe = function (_React$Component) {
  _inherits(TouchableNativeFeedbackSafe, _React$Component);

  function TouchableNativeFeedbackSafe() {
    _classCallCheck(this, TouchableNativeFeedbackSafe);

    return _possibleConstructorReturn(this, _getPrototypeOf(TouchableNativeFeedbackSafe).apply(this, arguments));
  }

  _createClass(TouchableNativeFeedbackSafe, [{
    key: "render",
    value: function render() {
      if (TouchableComponent === TouchableNativeFeedback) {
        return React.createElement(TouchableComponent, _extends({}, this.props, {
          style: {},
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        }), React.createElement(View, {
          style: this.props.style,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        }, this.props.children));
      }

      return React.createElement(TouchableComponent, _extends({}, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      }), this.props.children);
    }
  }]);

  return TouchableNativeFeedbackSafe;
}(React.Component);

TouchableNativeFeedbackSafe.SelectableBackground = TouchableComponent.SelectableBackground;
TouchableNativeFeedbackSafe.SelectableBackgroundBorderless = TouchableComponent.SelectableBackgroundBorderless;
TouchableNativeFeedbackSafe.Ripple = TouchableComponent.Ripple;
export { TouchableNativeFeedbackSafe as default };